<template>

  <b-container fluid>
    <b-row class="p-0">
      <b-col class="px-0 py-2">
     <span v-if="!hasCustomFieldLabel">
       {{ fieldLabel }}
      <small v-if="labelTip" class="form-text text-warning font-weight-bold" style="display: inline; margin-left: 8px;">
        {{ labelTip || '&nbsp;' }}
      </small>
    </span>
      </b-col>
      <HintEditor
          ref="hint"
          :editor-mode="editorMode"
          :field-config="fieldConfig"
          :help-message="fieldConfig.htmlHelpText"
          :help-title="fieldConfig.helpWindowTitle"
          :validated-field="validatedField"
      >
      </HintEditor>
    </b-row>

    <b-row class="p-0">
      <b-col class="p-0">
        <b-container fluid class="border mb-2 p-0">
          <b-row v-for="item in items" :key="item._key" :data-input-index="item._index"
                 class="p-0 m-0 align-items-center">
            <div :class="readOnly ? 'col-sm-11 col-11' : 'col-sm col-12'" class="p-0 m-0 pt-2">
              <EntityEditForm
                  ref="nestedItems"
                  :embedded="true"
                  :formConfig="itemFormConfig"
                  :mode="mode"
                  :editAfterStart="!readOnly"
                  :read-only-inputs="validatedField.readOnly || !writePermitted"
                  :editor-mode="editorMode"
                  :temporaryInstanceToEdit="item.instance"
                  @can-submit-change="itemCanSubmitChange(item)"
                  @form-update="itemFormUpdate(item)"
                  @unsavedChanges="itemUnsaveChange(item)"
                  :directParentFormModel="validatedField ? validatedField.validatedForm : null"
                  :masterFormModel="masterFormModel"
                  :fields-filter="fieldsFilter"
              ></EntityEditForm>
            </div>
            <b-col cols="12" sm="auto" v-if="validatedField && !validatedField.readOnly && !fixedSize">
              <FooterButton
                  :class="{'d-flex': isMobile, 'justify-content-center': isMobile, 'align-items-center': isMobile}"
                  :disabled="!canDelete || !writePermitted" :showLabel="false" type="Delete"
                  @delete="remove(item)"></FooterButton>
            </b-col>

          </b-row>

          <b-row style="padding-top: 3px" class="px-2">
            <!--            <b-col cols="col-auto pr-0 pl-3">-->
            <!--              <HintEditor-->
            <!--                ref="hint"-->
            <!--                :validated-field="validatedField"-->
            <!--                :field-config="fieldConfig"-->
            <!--                :editor-mode="editorMode"-->
            <!--                :help-message="fieldConfig.htmlHelpText"-->
            <!--                :help-title="fieldConfig.helpWindowTitle"-->
            <!--              >-->
            <!--              </HintEditor>-->
            <!--            </b-col>-->
            <b-col class="p-0">
              <small v-if="(validatedField && validatedField.isValid) " style="margin-top: 2px; margin-left: 10px;"
                     :class="{'d-flex': isMobile, 'justify-content-center': isMobile, 'align-items-center': isMobile}"
                     class="form-text text-muted"> {{ fieldConfig.shortHelpText || '&nbsp;' }}
              </small>
              <small v-else style="margin-top: 2px; margin-left: 10px;"
                     :class="{'d-flex': isMobile, 'justify-content-center': isMobile, 'align-items-center': isMobile}"
                     class="form-text text-danger">{{ validatedField ? validatedField.errorMessage || '&nbsp;' : ' ' }}
              </small>
            </b-col>
            <b-col style="height: 28px;" class="pt-1 pl-0 pr-0 col-auto">
              <transition name="fade">
                <b-spinner
                    v-if="validatedField && (validatedField.validationInProgress || validatedField.detailsLoadInProgress)"
                    variant="plm-primary"
                    small
                    label="Spinning">
                </b-spinner>
              </transition>
            </b-col>
          </b-row>

          <b-row class="pt-1 px-2 pb-2">
            <b-col>
              <FooterButton
                  v-if="validatedField && !validatedField.readOnly && !fixedSize"
                  type="New"
                  :disabled="!canAdd || !writePermitted"
                  @new="add"
                  :long-size="true"
              ></FooterButton>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>


<script>

import FormValidatedField from "@/components/forms/FormValidatedField";
import EntityEditForm from "@/components/forms/EntityEditForm";
import ListFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/ListFormFieldConfig";
import FormsLoader from "@/components/forms/FormsLoader";
import FormModel from "@/components/forms/FormModel";
import DialogManager from "@/utils/DialogManager";
import FooterButton from "@/components/navbar/FooterButton";
import HintEditor from "@/components/inputs/controls/HintEditor";
import {
  findFieldValueFromCompanyCompanyConfigurationForm, findFieldValueFromCompanyCompanyConfigurationFormField
} from "@/components/forms/customizations/plm/EntityEditFormService";

let idGenerator = 1;
// przy dodawaniu obiektow/ ladowaniu obiektow dokleic
// __rowGroupId = idGenerator ++;
export default {
  name: "RowsGroupRenderer",
  components: {FooterButton, EntityEditForm, HintEditor},
  created() {
    this.valChange(this.validatedField?.value);
  },

  async mounted() {
    this.assignLabelTip();
    this.isMobile = window.innerWidth < 768; // Ustawienie wartości na podstawie szerokości okna
    window.addEventListener('resize', this.handleResize);

    setTimeout(() => {
      let fieldConfig = FormsLoader.detectFormConfig(this.fieldConfig.elementClazz);
      this.writePermitted = fieldConfig.writePermitted;
      if (this.fieldConfig.autofocus) {
        setTimeout(() => this.afterMounted());
      }
      if (this.fieldConfig.maxItems === this.fieldConfig.minItems || this.fieldConfig.fixedSize) {
        this.fixedSize = true;
      }
      this.validatedField.__subItems__ = this.items;
      this.setLabel();
    }, 2000);

  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  props: {
    validatedField: {type: FormValidatedField, required: true},
    fieldConfig: {type: ListFormFieldConfig, required: true},
    context: {default: null},
    mode: {default: null},
    parentForm: {type: FormModel},
    masterFormModel: {default: null},
    hasCustomFieldLabel: {default: false},
    fieldsFilter: {default: null}
  },

  //this.formModel.fields.x.value -> to jest zazwyczaj
  //this.formModel.fields.remarks._value[0].dateAdded.value -> mode === "EDIT"
  // kluczowe bedzie dodanie tego jeszcze jednego value bo <localDate.value

  methods: {
    handleResize() {
      this.isMobile = window.innerWidth < 768;
    },
    setReadOnly(readOnly) {
      this.readOnly = this.fieldConfig.readOnly || readOnly;
      if (this.$refs.nestedItems?.length) {
        for (let nestedEntityEditForm of this.$refs.nestedItems) {
          if (!this.readOnly) {
            nestedEntityEditForm.edit();
          }
        }
      }
    },
    setEditorMode(val) {
      this.editorMode = val
    },

    setLabel() {
      let customLabel = findFieldValueFromCompanyCompanyConfigurationFormField(this.parentForm.formConfig, this.fieldConfig,
          "alternativeFieldLabel");
      this.fieldLabel = customLabel?.length ? customLabel : this.itemFormConfig.entityPlural;
    },

    afterMounted() {
      // if(!this.readOnly) {
      //   this.$refs.input.focus();
      // }
    },

    focusIn() {
    },

    focusOut() {
//      this.validatedField?.validate();
    },

    itemCanSubmitChange() {
      let canSubmit = true;
      this.items.forEach(value => canSubmit = canSubmit && value.form.canSubmit);
      this.canSubmit = canSubmit;
      this.validatedField.canSubmit = this.canSubmit;
    },

    itemFormUpdate(item) {
      this.collecting = true;
      try {
        item.form.collectInputs();
        this.validatedField.value = this.items.map(value => value.instance);
        this.validatedField.notify();
      } finally {
        this.collecting = false
      }
    },

    itemUnsaveChange(item) {

    },

    remove(item) {
      let toRemove = this.items.findIndex(el => el._key === item._key);
      let itemToRemove = this.items[toRemove];
      if (toRemove >= 0) {
        this.items.splice(toRemove, 1);
      }
      toRemove = this.validatedField?.value?.findIndex(el => el.__rowGroupId === item._key);
      if (toRemove != null && toRemove >= 0) {
        this.validatedField.value.splice(toRemove, 1);
        this.itemCanSubmitChange();
      }
      this.validatedField.notify();
      this.checkNumberOfItems();
    },

    checkNumberOfItems() {
      if (this.items.length <= this.fieldConfig.minItems) {
        this.canDelete = false;
      } else {
        this.canDelete = true;
      }
      if (this.items.length >= this.fieldConfig.maxItems) {
        this.canAdd = false;
      } else {
        this.canAdd = true;
      }
    },

    add(list) {
      list = list ?? this.items;
      let form = new FormModel(this.itemFormConfig, this.presetFields);
      form.directParentFormModel = this.validatedField.validatedForm;
      form.masterFormModel = this.masterFormModel;

      form.newEntitySync();
      let instance = form.originalSource;
      instance.__formModel__ = form;
      instance.__rowGroupId = idGenerator++;

      list.push({
        _key: instance.__rowGroupId,
        instance,
        form
      });
      this.checkNumberOfItems();
      this.validatedField.value = this.items.map(value => value.instance);
      this.validatedField.notify();
    },
    /**
     * @param {Array} val
     */
    valChange(val) {
      try {
        this.processingChange = true;
        this.itemFormConfig = FormsLoader.detectFormConfig(this.fieldConfig.elementClazz);

        if (!val) {
          let items = [];
          if (this.mode === "NEW") {
            this.addMissing(items);
          }
          this.items = items;
          this.checkNumberOfItems();

          return;
        }

        let num = 0;

        this.validatedField.__subItems__ = [];
        let items = val.map(entity => {
          if (!entity.__formModel__) {
            let form = new FormModel(this.itemFormConfig, this.presetFields);
            form.directParentFormModel = this.validatedField.validatedForm;
            form.masterFormModel = this.masterFormModel;

            entity.__formModel__ = form;
            form.editMode(entity);

            if (entity?.__rowGroupId == null) {
              entity.__rowGroupId = idGenerator++;
            }
          }
          return {
            _key: entity.__rowGroupId,
            instance: entity,
            form: entity.__formModel__
          }
        });

        this.addMissing(items);
        for (let item of this.items) {
          if (item?.__rowGroupId == null) {
            item.__rowGroupId = idGenerator++;
          }
        }

        this.items = items;
        let startIndex = 0;
        this.items.forEach(x => {
          x._index = startIndex++;
        })
        this.checkNumberOfItems();
      } finally {
        this.processingChange = false;
      }
    },
    /**
     * @param {Array} items
     */
    addMissing(items) {
      while (items.length < this.fieldConfig.minItems) {
        this.add(items);
      }
    },
    assignLabelTip() {
      let fieldConfig = this.fieldConfig;
      if (!fieldConfig) {
        fieldConfig = this.validatedField.formFieldConfig;
      }
      let validatedField = this.validatedField;
      let formId = validatedField.validatedForm?.formConfig?.formId;
      if (formId) {
        this.labelTip = findFieldValueFromCompanyCompanyConfigurationFormField(validatedField.validatedForm?.formConfig, fieldConfig, "labelTip");
      }
    },
  },
  watch: {
    'validatedField': function (val) {
      if (this.processingChange) {
        return;
      }
      this.valChange(val.value);
    },
    'validatedField.value': function (val) {
      if (this.processingChange) {
        return;
      }
      let stamp = JSON.stringify(val);
      if (!this.oldVal) {
        this.oldVal = stamp;
      } else {
        if (stamp === this.oldVal) {
          return;
        }
        this.oldVal = stamp;
      }

      this.valChange(val);
    },
    'items': function (val) {
      this.validatedField.__subItems__ = val;
    }
  },

  data: function () {
    return {
      labelTip: null,
      items: [],
      processingChange: false,
      fixedSize: false,
      canDelete: true,
      /** @type {FormConfig}*/
      itemFormConfig: null,
      presetFields: [],
      collecting: false,
      canAdd: true,
      canSubmit: true,
      readOnly: true,
      editorMode: false,
      hintInputMessage: "",
      formModel: this.validatedField.validatedForm,
      formConfig: this.validatedField.getFormConfig(),
      writePermitted: false,
      isMobile: false,
      fieldLabel: ""
    }
  }
}
</script>

<style scoped>

</style>